import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { companyHasActiveFeature } from "../../../routes/roleOnly";
import TrainingAdminWorkspace from "./TrainingAdminWorkspace";
import TrainingWorkspace from "./TrainingWorkspace";
import TrainingAdminReports from "./TrainingAdminReports";
import { useTranslation } from "react-i18next";
import { HsePageChrome } from "../hse/HsePageChrome";
import { HsePageBody } from "../hse/HsePageBody";
import {
  CompetencySubnav,
  COMPETENCY_PATHS,
} from "../hse/competency/CompetencySubnav";

// Routes remain readable after cancellation; mutation entitlement is explicit.
// Re-mount on real session/company changes so stale drafts cannot cross tenants.
export function TrainingAdminRoute() {
  const company = useSelector((state) => state.session.currentCompany);
  const user = useSelector((state) => state.session.currentUser);
  const contextKey = `${company?.id}:${user?.id}`;
  if (!user?.roles?.some((role) => role.name === "admin")) return null;
  return (
    <TrainingAdminWorkspace
      key={contextKey}
      contextKey={contextKey}
      navigation={<CompetencySubnav active="training" />}
      enabled={companyHasActiveFeature(company, "training_guides")}
    />
  );
}
export function TrainingAdminLegacyRedirect() {
  const location = useLocation();
  return (
    <Navigate
      replace
      to={{
        pathname: COMPETENCY_PATHS.training,
        search: location.search,
        hash: location.hash,
      }}
    />
  );
}
export function TrainingUserRoute() {
  const { t } = useTranslation();
  const companyId = useSelector((state) => state.session.currentCompany?.id);
  const userId = useSelector((state) => state.session.currentUser?.id);
  return <HsePageChrome title={t("trainingParticipant.title")} subtitle={t("trainingParticipant.intro")}>
    <HsePageBody className="min-w-0 pb-8"><TrainingWorkspace key={`${companyId}:${userId}`} /></HsePageBody>
  </HsePageChrome>;
}
export function TrainingResponsibleRoute() {
  const { t } = useTranslation();
  const companyId = useSelector((state) => state.session.currentCompany?.id);
  const userId = useSelector((state) => state.session.currentUser?.id);
  return (
      <HsePageChrome
        title={t("trainingAdmin.responsibleReports")}
        backUrl="/dashboard/training"
      >
      <HsePageBody className="min-w-0 space-y-5 pb-8">
      <TrainingAdminReports
        key={`${companyId}:${userId}`}
        enabled={false}
        responsibleOnly
      />
      </HsePageBody>
      </HsePageChrome>
  );
}
